module.exports = __webpack_public_path__ + "9a3ad115ca6c705730c385ed02cbcfe5.fbx";